import { Link } from "react-router-dom";
import "./usecase.css";

export default function UseCaseMax() {
  return (
    <div className="uc-sheet" data-testid="usecasemax-page">
      <main className="sheet">
        <header className="bar">
          <div className="brand"><span className="brand-mark">B</span>La Bascule</div>
          <span className="pill">Use case · 02 · Régie → Forfait</span>
        </header>

        <section className="hero">
          <aside className="id-card">
            <div className="photo">
              <span className="initials">M</span>
              <span className="hint">Photo à insérer</span>
            </div>
            <div className="who">
              <h1>Maxence</h1>
              <p>Lead Dév PHP freelance</p>
            </div>
            <div className="facts">
              <div className="fact"><b>480 €</b><span>TJM en régie</span></div>
              <div className="fact"><b>×2+</b><span>CA vs TJM</span></div>
            </div>
          </aside>

          <div className="headline">
            <span className="eyebrow">Résultat membre</span>
            <h2><em>25 K€</em> de CA mensuel moyen sur 6 mois.</h2>
            <p className="lede">Faute de première mission en régie, Maxence a construit une offre de solutions web pour les commerces physiques locaux. Il pilote aujourd'hui une équipe de freelances et facture plus du double de ce que lui rapporterait son TJM.</p>
            <div className="shift">
              <span className="from">480 €/j · ≈ 10 K€/mois</span>
              <span className="arrow">→</span>
              <span className="to">25 K€/mois · forfait</span>
            </div>
          </div>
        </section>

        <section className="grid">
          <article className="block parcours">
            <span className="eyebrow">Chapitre 01 — Le parcours</span>
            <h3>Un Lead Dév qui attendait sa première mission</h3>
            <p className="summary">Lead Développeur PHP, Maxence se lance en freelance avec un TJM de 480 €. La première mission en régie tarde à venir. Plutôt que d'attendre, il décide de vendre directement ce qu'il sait construire.</p>
            <ul className="timeline">
              <li><div><b>Lead Dév PHP</b><span>Expertise technique · TJM 480 €/j</span></div></li>
              <li><div><b>Lancement en freelance</b><span>Recherche de mission en régie, longue</span></div></li>
              <li><div><b>Offre web pour commerces locaux</b><span>Forfait packagé · La Bascule</span></div></li>
            </ul>
            <div className="chips">
              <span className="chip">PHP</span>
              <span className="chip">Lead technique</span>
              <span className="chip">Solutions web</span>
              <span className="chip">Commerces locaux</span>
            </div>
          </article>

          <article className="block motiv">
            <span className="eyebrow">Chapitre 02 — Le déclic</span>
            <h3>Pourquoi Maxence a voulu basculer</h3>
            <div className="motiv-list">
              <div className="m">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 12a9 9 0 1 1-3-6.7"/><path d="M21 4v5h-5"/></svg>
                <b>Faire tourner son activité</b>
                <p>Mettre ses compétences à profit tout de suite, sans attendre qu'une mission se libère.</p>
              </div>
              <div className="m">
                <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/><path d="M5 19 19 5"/></svg>
                <b>Découpler revenus et temps</b>
                <p>Ne plus lier 100 % de ses revenus à un modèle où il vend ses heures.</p>
              </div>
              <div className="m">
                <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="5" r="2.5"/><circle cx="5" cy="18" r="2.5"/><circle cx="19" cy="18" r="2.5"/><path d="M10.8 7.2 6.2 15.8"/><path d="m13.2 7.2 4.6 8.6"/></svg>
                <b>Ne pas dépendre d'un seul client</b>
                <p>Répartir son chiffre d'affaires sur plusieurs clients pour ne jamais tout perdre d'un coup.</p>
              </div>
            </div>
          </article>

          <article className="block actions">
            <span className="eyebrow">Chapitre 03 — Ce qu'on a construit ensemble</span>
            <h3>Une offre testée, un flux de rendez-vous, une équipe</h3>
            <div className="steps">
              <div className="step">
                <span className="n">01 · OFFRE</span>
                <b>Cadrage de l'offre et de l'ICP</b>
                <p>Offre et client idéal affinés par périodes de test successives, jusqu'à trouver ce qui signe.</p>
                <div className="tags"><span className="chip">Testing</span><span className="chip">ICP</span><span className="chip">Commerces locaux</span></div>
              </div>
              <div className="step">
                <span className="n">02 · ACQUISITION</span>
                <b>Pipeline de leads</b>
                <p>Un moteur de prospection qui remplit l'agenda chaque semaine.</p>
                <span className="stat">17 <small>rdv / semaine en moyenne</small></span>
              </div>
              <div className="step">
                <span className="n">03 · DELIVERY</span>
                <b>Team de sous-traitants freelance</b>
                <p>Une équipe montée dans son propre réseau, pour livrer plus de projets que son seul temps ne le permet.</p>
                <div className="team" aria-label="Maxence et son réseau de sous-traitants">
                  <span className="lead">Maxence</span><span className="link">→</span>
                  <span className="sub">FL</span><span className="sub">FL</span><span className="sub">FL</span><span className="sub">+</span>
                </div>
              </div>
            </div>
          </article>

          <article className="block result">
            <div className="res-copy">
              <span className="eyebrow">Chapitre 04 — Le résultat</span>
              <h3>Une mise en place longue, puis une offre qui tourne.</h3>
              <ul className="deals">
                <li><span className="when">Mois 1-2</span><div><b>Structuration de l'offre</b><span>Tests de l'offre et de l'ICP, construction du pipeline</span></div><strong>Setup</strong></li>
                <li><span className="when">Mois 3</span><div><b>Première signature client</b><span>Offre de base, upsells possibles</span></div><strong>7 500 €</strong></li>
                <li><span className="when">6 mois</span><div><b>CA mensuel moyen</b><span>Plus de 2× le CA au TJM</span></div><strong>25 000 €</strong></li>
              </ul>
              <p>La mise en place a pris du temps, et c'est ce qui a rendu l'offre solide. Aujourd'hui elle se vend et se livre avec une équipe.</p>
            </div>
            <div className="kpis">
              <div className="kpi hl"><b>25 K€</b><span>CA mensuel moyen, 6 derniers mois</span></div>
              <div className="kpi hl"><b>×2+</b><span>Le CA d'un mois au TJM</span></div>
              <div className="kpi"><b>7,5 K€</b><span>Offre de base</span></div>
              <div className="kpi"><b>10 K€</b><span>Panier avec upsell</span></div>
            </div>
          </article>

          <article className="compare" aria-label="CA mensuel en régie et en forfait">
            <span className="eyebrow" style={{ gridColumn: "1 / -1" }}>CA mensuel : régie vs offre packagée</span>
            <span className="lab">Régie · 480 €/j</span>
            <div className="track"><div className="fill old" style={{ width: "40.3%" }}>≈ 10 K€</div></div>
            <span className="lab">Offre · 6 derniers mois</span>
            <div className="track"><div className="fill new" style={{ width: "100%" }}>25 K€</div></div>
            <p className="cap">Régie calculée sur un mois plein de 21 jours facturés à 480 €, soit environ 10 K€. L'offre packagée en génère 25 K€ en moyenne, sans plafond lié à son temps.</p>
          </article>
        </section>

        <footer className="foot">
          <span className="url">la-bascule.io</span>
          <Link className="cta" to="/offre" data-testid="usecasemax-cta">Booker mon Check Up ↗</Link>
        </footer>
      </main>
    </div>
  );
}
